module.exports = "https://coinrabbit.io/_next/static/images/step2Illustration-ae2618d2e505608808b32902fd520dcf.svg";